const sanitizePhone = (phone: string | number) => {
  return phone.toString().replace(/[^\d+()\- ]/g, '')
}

export default sanitizePhone
